import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface IForgotPasswordFormData {
  email: string
}

const ForgotPasswordSchema: JSONSchemaType<IForgotPasswordFormData> = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'E-Mail Inválido',
    },
  },
  required: ['email'],
  additionalProperties: false,
}

export default ForgotPasswordSchema
